<template>
  <v-app id="inspire" class="bodyPadding"> 
    <mo-header></mo-header>
    <v-content>
		<role-head></role-head>		
		<role-list></role-list>
    </v-content>
  </v-app>
</template>

<script>

	import RoleHead from './Header.vue';	
	import RoleList from './List.vue';

	export default {
		data () {
			return {
		
			}		
		},
		components: {
			RoleHead,			
			RoleList
		}
	}
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>